import store from '@/store'
import { MessageBox } from "element-ui";
import MetaMaskOnboarding from "@metamask/onboarding";

const $_showVal = (value) => {
  let res = "";
  if(value){
    if(value.length > 10){
      res = value.substring(0,5) + "..." + value.substring(value.length - 4)
    }else{
      res = value;
    }
  }
  return res;
}
/**
 * res:0 Metamask account mismatch
 * res:1 Metamask account matching succeeded
 * res:-1 Metamask is not installed
 */
export function CheckAccount(){
    if(!store.getters.metaMaskObj.initOk){
      return {res: "1"}
    }
    if(!store.getters.metaMaskObj.isInstall){
      MessageBox.confirm(`You have not installed metamask. Please install it first. If it is already installed, please refresh your browser.`, "Tips", {
        confirmButtonText: "Install",
        showCancelButton: false,
        type: "warning"
      }).then(() => {
        const onboarding = new MetaMaskOnboarding();
        onboarding.startOnboarding();
      }).catch(e => {});
      return {res: "-1"}
    }
    const userInfo = store.getters.userInfo;
    let metaAccount = store.getters.metaMaskObj.account;
    metaAccount = metaAccount && metaAccount.toUpperCase();
    if(+userInfo.type == 0){
      if(userInfo.account && metaAccount && (userInfo.account.toUpperCase() != metaAccount)){
        MessageBox.confirm(`Please use your authenticated account: ${$_showVal(userInfo.account)}`, "Tips", {
          confirmButtonText: "Close",
          showCancelButton: false,
          type: "warning"
        }).then(() => {}).catch(e => {});
        return {res: "0"}
      }
      else if(!metaAccount){
        MessageBox.confirm(`Please use your authenticated account: ${$_showVal(userInfo.account)}`, "Tips", {
          confirmButtonText: "Close",
          showCancelButton: false,
          type: "warning"
        }).then(() => {}).catch(e => {});
        return {res: "0"}
      }
      else{
        return {res: "1"}
      }
    }
    else if(+userInfo.type == 1){
      if(!metaAccount){
        return {res: "0"}
      }
      let FoundationManager = store.getters.metaMaskObj.FoundationManager;
      FoundationManager = FoundationManager && FoundationManager.toUpperCase();
      if(FoundationManager && metaAccount && (FoundationManager != metaAccount)){
        MessageBox.confirm(`Please use the account specified by the role to operate!(Account: ${$_showVal(FoundationManager)})`, "Tips", {
          confirmButtonText: "Close",
          showCancelButton: false,
          type: "warning"
        }).then(() => {}).catch(e => {});
        return {res: "0"}
      }
      else if(!metaAccount){
        MessageBox.confirm(`Please use the account specified by the role to operate!(Account: ${$_showVal(FoundationManager)})`, "Tips", {
          confirmButtonText: "Close",
          showCancelButton: false,
          type: "warning"
        }).then(() => {}).catch(e => {});
        return {res: "0"}
      }
      else{
        return {res: "1"}
      }
    }
    else if(+userInfo.type == 2){
      if(!metaAccount){
        return {res: "0"}
      }
      let Auditor = store.getters.metaMaskObj.Auditor;
      Auditor = Auditor && Auditor.toUpperCase();
      if(Auditor && metaAccount && (Auditor != metaAccount)){
        MessageBox.confirm(`Please use the account specified by the role to operate!(Account: ${$_showVal(Auditor)})`, "Tips", {
          confirmButtonText: "Close",
          showCancelButton: false,
          type: "warning"
        }).then(() => {}).catch(e => {});
        return {res: "0"}
      }
      else if(!metaAccount){
        MessageBox.confirm(`Please use the account specified by the role to operate!(Account: ${$_showVal(Auditor)})`, "Tips", {
          confirmButtonText: "Close",
          showCancelButton: false,
          type: "warning"
        }).then(() => {}).catch(e => {});
        return {res: "0"}
      }
      else{
        return {res: "1"}
      }
    }
    else{
      return {res: "1"}
    }
};


